/* // eslint-disable */
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, Typography } from '@material-ui/core';
import MaterialTable from 'material-table';
import clsx from 'clsx';
// import useQuickBook from '../../../../hooks/useQuickBook';
// import usePractice from '../../../../hooks/usePractice';
// import useImport from '../../../../hooks/useImport';

/* CSS */
import useStyles from '../../Main.style';
import Loader from '../../../../components/Loader/Loader';

const CollectionReport = ({
  collectionDataFromImportProp,
  pastDueInvoicesArr,
  pastDueTableArr,
}) => {
  const classes = useStyles();
  const key = 'iFrasCwdJh';
  // const { getCountry } = usePractice();
  // const { getCollectionReportDataForDisplay } = useImport();
  const userCookie = Cookies.get('user');
  const bytes = CryptoJS.AES.decrypt(userCookie, key);
  const [pastDueTableObject, setPastDueTableObject] = useState([]);
  const loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  const [cellDetails] = useState(loggedInUserData?.cell);
  const [isLoaded] = useState(true);
  const [displayedTcData, setDisplayedTcData] = useState([]);
  const [pastDueTop5Collection, setPastDueTop5Collection] = useState('');
  async function findObjectBySearchText(obj, searchText) {
    if (typeof obj === 'object') {
      let result;

      if (Array.isArray(obj)) {
        for (let i = 0; i < obj?.length; i += 1) {
          // eslint-disable-next-line
          result = await findObjectBySearchText(obj[i], searchText, obj);
          if (result) {
            return result;
          }
        }
      } else {
        // eslint-disable-next-line
        for (const prop in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            // eslint-disable-next-line
            result = await findObjectBySearchText(obj[prop], searchText, obj);
            if (result) {
              return result;
            }
            if (
              typeof obj[prop] === 'string' &&
              obj[prop].toLowerCase().indexOf(searchText.toLowerCase()) !== -1
            ) {
              return { object: obj };
            }
          }
        }
      }
    }
    return null;
  }
  const fillPastDueTotals = async (reportObj) => {
    const tableData = [];
    // eslint-disable-next-line
    let totalTopFive = 0;
    let totalCellCollection = 0;
    const columnTotal = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    // eslint-disable-next-line
    reportObj?.Rows?.Row?.sort((ad, bd) => {
      const adVal = ad?.ColData && parseFloat(ad?.ColData[1]?.value);
      const bdVal = bd?.ColData && parseFloat(bd?.ColData[1]?.value);
      if (adVal && bdVal) {
        return bdVal - adVal;
        // eslint-disable-next-line
      } else if (adVal) {
        return -1;
      } else if (bdVal) {
        return 1;
      } else {
        return 0;
      }
    }).map((c, index) => {
      if (c?.ColData) {
        if (index < 5) {
          columnTotal[0] += parseFloat(
            c?.ColData[2]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[2]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || 0,
          );
          columnTotal[1] += parseFloat(
            c?.ColData[1]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[1]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[2] += parseFloat(
            c?.ColData[3]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[3]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[3] += parseFloat(
            c?.ColData[4]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[4]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[4] += parseFloat(
            c?.ColData[5]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[5]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[5] += parseFloat(
            c?.ColData[6]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[6]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[6] += parseFloat(
            c?.ColData[7]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[7]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[7] += parseFloat(
            c?.ColData[8]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[8]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[8] = Number(
            columnTotal[0] +
              columnTotal[2] +
              columnTotal[3] +
              columnTotal[4] +
              columnTotal[5] +
              columnTotal[6] +
              columnTotal[7],
          );

          columnTotal[9] += parseFloat(
            c?.ColData[9]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[9]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[10] +=
            c?.ColData[1]?.value === '' ? 0 : parseFloat(c?.ColData[1]?.value || 0);

          const tableRowObj = {
            client: c?.ColData[0]?.value,
            current:
              // eslint-disable-next-line
              c?.ColData[1].value === '' ? (
                '$0.00'
              ) : Number(parseFloat(c?.ColData[1]?.value).toFixed(2)) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(parseFloat(c?.ColData[1]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })})`}
                </span>
              ) : (
                `$${Number(parseFloat(c?.ColData[1]?.value).toFixed(2)).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),
            zerotofifteendays:
              // eslint-disable-next-line
              c?.ColData[2].value === '' ? (
                '$0.00'
              ) : Number(parseFloat(c?.ColData[2]?.value).toFixed(2)) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(parseFloat(c?.ColData[2]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })})`}
                </span>
              ) : (
                `$${Number(parseFloat(c?.ColData[2]?.value).toFixed(2)).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),
            sixteentothirtydays:
              // eslint-disable-next-line
              c?.ColData[3].value === '' ? (
                '$0.00'
              ) : Number(parseFloat(c?.ColData[3]?.value).toFixed(2)) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(parseFloat(c?.ColData[3]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })})`}
                </span>
              ) : (
                `$${Number(parseFloat(c?.ColData[3]?.value).toFixed(2)).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),
            thirtyonetofortyfivedays:
              // eslint-disable-next-line
              c?.ColData[4].value === '' ? (
                '$0.00'
              ) : Number(parseFloat(c?.ColData[4]?.value).toFixed(2)) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(parseFloat(c?.ColData[4]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })})`}
                </span>
              ) : (
                `$${Number(parseFloat(c?.ColData[4]?.value).toFixed(2)).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),
            fortysixtosixtydays:
              // eslint-disable-next-line
              c?.ColData[5].value === '' ? (
                '$0.00'
              ) : Number(parseFloat(c?.ColData[5]?.value).toFixed(2)) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(parseFloat(c?.ColData[5]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })})`}
                </span>
              ) : (
                `$${Number(parseFloat(c?.ColData[5]?.value).toFixed(2)).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),
            sixtyonetoseventyfivedays:
              // eslint-disable-next-line
              c?.ColData[6].value === '' ? (
                '$0.00'
              ) : Number(parseFloat(c?.ColData[6]?.value).toFixed(2)) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(parseFloat(c?.ColData[6]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })})`}
                </span>
              ) : (
                `$${Number(parseFloat(c?.ColData[6]?.value).toFixed(2)).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),
            seventysixtonintydays:
              // eslint-disable-next-line
              c?.ColData[7].value === '' ? (
                '$0.00'
              ) : Number(parseFloat(c?.ColData[7]?.value).toFixed(2)) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(parseFloat(c?.ColData[7]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })})`}
                </span>
              ) : (
                `$${Number(parseFloat(c?.ColData[7]?.value).toFixed(2)).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),
            morethannintyonedays:
              // eslint-disable-next-line
              c?.ColData[8].value === '' ? (
                '$0.00'
              ) : Number(parseFloat(c?.ColData[8]?.value).toFixed(2)) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(parseFloat(c?.ColData[8]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })})`}
                </span>
              ) : (
                `$${Number(parseFloat(c?.ColData[8]?.value).toFixed(2)).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),
            pastduebalance:
              (
                parseFloat(c?.ColData[2].value === '' ? 0 : c?.ColData[2]?.value) +
                parseFloat(c?.ColData[3].value === '' ? 0 : c?.ColData[3]?.value) +
                parseFloat(c?.ColData[4].value === '' ? 0 : c?.ColData[4]?.value) +
                parseFloat(c?.ColData[5].value === '' ? 0 : c?.ColData[5]?.value) +
                parseFloat(c?.ColData[6].value === '' ? 0 : c?.ColData[6]?.value) +
                parseFloat(c?.ColData[7].value === '' ? 0 : c?.ColData[7]?.value) +
                parseFloat(c?.ColData[8].value === '' ? 0 : c?.ColData[8]?.value)
              ).toFixed(2) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(
                    (
                      parseFloat(c?.ColData[2].value === '' ? 0 : c?.ColData[2]?.value) +
                      parseFloat(c?.ColData[3].value === '' ? 0 : c?.ColData[3]?.value) +
                      parseFloat(c?.ColData[4].value === '' ? 0 : c?.ColData[4]?.value) +
                      parseFloat(c?.ColData[5].value === '' ? 0 : c?.ColData[5]?.value) +
                      parseFloat(c?.ColData[6].value === '' ? 0 : c?.ColData[6]?.value) +
                      parseFloat(c?.ColData[7].value === '' ? 0 : c?.ColData[7]?.value) +
                      parseFloat(c?.ColData[8].value === '' ? 0 : c?.ColData[8]?.value)
                    ).toFixed(2) * -1,
                  ).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })})`}
                </span>
              ) : (
                `$${Number(
                  (
                    parseFloat(c?.ColData[2].value === '' ? 0 : c?.ColData[2]?.value) +
                    parseFloat(c?.ColData[3].value === '' ? 0 : c?.ColData[3]?.value) +
                    parseFloat(c?.ColData[4].value === '' ? 0 : c?.ColData[4]?.value) +
                    parseFloat(c?.ColData[5].value === '' ? 0 : c?.ColData[5]?.value) +
                    parseFloat(c?.ColData[6].value === '' ? 0 : c?.ColData[6]?.value) +
                    parseFloat(c?.ColData[7].value === '' ? 0 : c?.ColData[7]?.value) +
                    parseFloat(c?.ColData[8].value === '' ? 0 : c?.ColData[8]?.value)
                  ).toFixed(2),
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),

            overalloutstanding:
              parseFloat(c?.ColData[9]?.value === '' ? 0 : c?.ColData[9]?.value).toFixed(2) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(parseFloat(c?.ColData[9]?.value).toFixed(2) * -1).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    },
                  )})`}
                </span>
              ) : (
                `$${Number(parseFloat(c?.ColData[9]?.value).toFixed(2)).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),
          };

          totalTopFive += parseFloat(columnTotal[7]).toFixed(2).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          tableData.push(tableRowObj);
        }
        totalCellCollection += parseFloat(
          parseFloat(c?.ColData[2].value === '' ? 0 : c?.ColData[2]?.value) +
            parseFloat(c?.ColData[3].value === '' ? 0 : c?.ColData[3]?.value) +
            parseFloat(c?.ColData[4].value === '' ? 0 : c?.ColData[4]?.value) +
            parseFloat(c?.ColData[5].value === '' ? 0 : c?.ColData[5]?.value) +
            parseFloat(c?.ColData[6].value === '' ? 0 : c?.ColData[6]?.value) +
            parseFloat(c?.ColData[7].value === '' ? 0 : c?.ColData[7]?.value) +
            parseFloat(c?.ColData[8].value === '' ? 0 : c?.ColData[8]?.value),
        );
      }
    });
    const columnTotalObj = {
      client: 'Total',
      current:
        parseFloat(columnTotal[1]).toFixed(2) === 0
          ? '$0.00'
          : `$${Number(parseFloat(columnTotal[1]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
      zerotofifteendays:
        parseFloat(columnTotal[0]).toFixed(2) === 0
          ? '$0.00'
          : `$${Number(parseFloat(columnTotal[0]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
      sixteentothirtydays:
        parseFloat(columnTotal[2]).toFixed(2) === 0
          ? '$0.00'
          : `$${Number(parseFloat(columnTotal[2]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
      thirtyonetofortyfivedays:
        parseFloat(columnTotal[3]).toFixed(2) === 0
          ? '$0.00'
          : `$${Number(parseFloat(columnTotal[3]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
      fortysixtosixtydays:
        parseFloat(columnTotal[4]).toFixed(2) === 0
          ? '$0.00'
          : `$${Number(parseFloat(columnTotal[4]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
      sixtyonetoseventyfivedays:
        parseFloat(columnTotal[5]).toFixed(2) === 0
          ? '$0.00'
          : `$${Number(parseFloat(columnTotal[5]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
      seventysixtonintydays:
        parseFloat(columnTotal[6]).toFixed(2) === 0
          ? '$0.00'
          : `$${Number(parseFloat(columnTotal[6]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
      morethannintyonedays:
        parseFloat(columnTotal[7]).toFixed(2) === 0
          ? '$0.00'
          : `$${Number(parseFloat(columnTotal[7]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
      pastduebalance:
        parseFloat(columnTotal[8]).toFixed(2) === 0
          ? '$0.00'
          : `$${Number(parseFloat(columnTotal[8]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
      overalloutstanding:
        parseFloat(columnTotal[9]).toFixed(2) === 0
          ? '$0.00'
          : `$${Number(parseFloat(columnTotal[9]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
    };
    tableData.push(columnTotalObj);

    const pastDueInvoices = pastDueInvoicesArr;
    const pastDueInvTotalYtd = await findObjectBySearchText(
      pastDueInvoices?.reportResult,
      'GrandTotal',
    );

    const totalCompanyCollection = parseFloat(
      pastDueInvTotalYtd?.object?.Summary?.ColData[
        pastDueInvTotalYtd?.object?.Summary?.ColData.length - 1
      ]?.value,
    );

    const tableObject = {
      columns: reportObj?.Columns?.Column,
      rows: tableData,
      totalTopFive: parseFloat(columnTotal[7]).toFixed(2),
      totalCellCollection,
      totalCompanyCollection,
    };

    setPastDueTableObject(tableObject);
  };

  function formatCurrency(value) {
    // Convert to a number in case it's passed as a string
    const num = Number(value);
    // Use toLocaleString to format the number with commas and fixed to 2 decimal places
    const formattedValue = Math.abs(num).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    // Check if the number is negative; if so, format as (-$amount), otherwise as $amount
    return num < 0 ? `(-$${formattedValue})` : `$${formattedValue}`;
  }

  const createCollectionDataFromImport = async (data) => {
    console.log(loggedInUserData?.cellId, 1111, data);
    const importedDataArray = [];
    const totals = {
      currentAmount: 0,
      past1to15: 0,
      past16to30: 0,
      past31to45: 0,
      past46to60: 0,
      past61to75: 0,
      past76to90: 0,
      past91: 0,
    };
    // eslint-disable-next-line
    data
      ?.filter((d) => d?.cellId === loggedInUserData?.cellId)
      .map((item, index) => {
        if (index < 5) {
          const pastDueBalance =
            parseFloat(item.past1to15) +
            parseFloat(item.past16to30) +
            parseFloat(item.past31to45) +
            parseFloat(item.past46to60) +
            parseFloat(item.past61to75) +
            parseFloat(item.past76to90) +
            parseFloat(item.past91);

          const overallOutstanding = parseFloat(item.currentAmount) + pastDueBalance;

          importedDataArray.push({
            client: item.clientName,
            current: formatCurrency(item.currentAmount),
            zerotofifteendays: formatCurrency(item.past1to15),
            sixteentothirtydays: formatCurrency(item.past16to30),
            thirtyonetofortyfivedays: formatCurrency(item.past31to45),
            fortysixtosixtydays: formatCurrency(item.past46to60),
            sixtyonetoseventyfivedays: formatCurrency(item.past61to75),
            seventysixtonintydays: formatCurrency(item.past76to90),
            morethannintyonedays: formatCurrency(item.past91),
            pastduebalance: formatCurrency(pastDueBalance),
            overalloutstanding: formatCurrency(overallOutstanding),
            tableData: { id: index },
            cellId: item.cellId,
          });

          // Update totals
          totals.currentAmount += parseFloat(item.currentAmount);
          totals.past1to15 += parseFloat(item.past1to15);
          totals.past16to30 += parseFloat(item.past16to30);
          totals.past31to45 += parseFloat(item.past31to45);
          totals.past46to60 += parseFloat(item.past46to60);
          totals.past61to75 += parseFloat(item.past61to75);
          totals.past76to90 += parseFloat(item.past76to90);
          totals.past91 += parseFloat(item.past91);
        }
      });

    setPastDueTop5Collection(
      formatCurrency(
        parseFloat(
          totals.past1to15 +
            totals.past16to30 +
            totals.past31to45 +
            totals.past46to60 +
            totals.past61to75 +
            totals.past76to90 +
            totals.past91,
        ),
      ),
    );

    setDisplayedTcData([]);
    setDisplayedTcData(importedDataArray);
    // setCollectionDataFromImport(importedDataArray);
  };

  const loadPastDueTableByCell = async () => {
    if (cellDetails?.qbId) {
      const pastDueTable = pastDueTableArr;
      fillPastDueTotals(pastDueTable?.reportResult);
    }
  };

  const loadCollectionDataFromImport = async () => {
    const result = collectionDataFromImportProp;
    if (result?.crResult && result?.crResult?.length > 0) {
      createCollectionDataFromImport(result?.crResult);
      return true;
      // eslint-disable-next-line
    } else {
      return false;
    }
  };

  useEffect(() => {
    loadPastDueTableByCell();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    loadCollectionDataFromImport().then((data) => {
      if (!data) loadPastDueTableByCell();
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    loadCollectionDataFromImport();
    // eslint-disable-next-line
  }, [pastDueTop5Collection]);

  return (
    <>
      <If condition={!isLoaded}>
        <Loader />
      </If>
      <If condition={isLoaded}>
        {/* Total collection COMPONENT */}
        <If condition={cellDetails?.qbId}>
          {' '}
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h5">Collections Report</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className={clsx(classes.innercontentWhite)}>
                  <Box>
                    <Box display="flex" alignItems="center" mb={2}>
                      <Box>
                        <Typography
                          variant="h5"
                          noWrap
                          className={classes.CollectionsReportSectionHeading}
                        >
                          My Cell&rsquo;s Top 5 Collections Accounts
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Typography variant="h2" noWrap className={classes.CollectionsReportRedText}>
                        {displayedTcData?.length > 0
                          ? pastDueTop5Collection
                          : `$${parseFloat(pastDueTableObject?.totalTopFive).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}`}
                      </Typography>
                      <Typography
                        variant="h6"
                        noWrap
                        className={classes.CollectionsReportDueBalance}
                      >
                        Past Due Balance
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className={clsx(classes.innercontentWhite)}>
                  <Box>
                    <Box display="flex" alignItems="center" mb={2}>
                      <Box>
                        <Typography
                          variant="h5"
                          noWrap
                          className={classes.CollectionsReportSectionHeading}
                        >
                          My Cell&rsquo;s Total Collections Accounts
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Typography variant="h2" noWrap className={classes.CollectionsReportRedText}>
                        {`$${parseFloat(
                          pastDueTableObject?.totalCellCollection?.toFixed(2),
                        ).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}`}
                      </Typography>
                      <Typography
                        variant="h6"
                        noWrap
                        className={classes.CollectionsReportDueBalance}
                      >
                        Past Due Balance
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className={clsx(classes.innercontentWhite)}>
                  <Box>
                    <Box display="flex" alignItems="center" mb={2}>
                      <Box>
                        <Typography
                          variant="h5"
                          noWrap
                          className={classes.CollectionsReportSectionHeading}
                        >
                          Company Total Collections Accounts
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Typography variant="h2" noWrap className={classes.CollectionsReportRedText}>
                        {`$${parseFloat(
                          pastDueTableObject?.totalCompanyCollection?.toFixed(2),
                        ).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}`}
                      </Typography>
                      <Typography
                        variant="h6"
                        noWrap
                        className={classes.CollectionsReportDueBalance}
                      >
                        Past Due Balance
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} className={classes.TableTotalUI}>
                <Box
                  className={clsx(classes.innercontentWhite, classes.CollectionsReportTableMobile)}
                >
                  <MaterialTable
                    style={{ boxShadow: 'none' }}
                    className={classes.materialDT}
                    options={{
                      toolbar: false,
                      draggable: false,
                      paging: false,
                      sorting: false,
                      pageSize: 20,
                      pageSizeOptions: [10, 20, 50, 100],
                      showTextRowsSelected: false,
                      toolbarButtonAlignment: 'right',
                      showFirstLastPageButtons: false,
                      actionsColumnIndex: -100,
                      emptyRowsWhenPaging: false,
                    }}
                    localization={{
                      pagination: {
                        labelRowsSelect: 'Rows',
                        labelRowsPerPage: 'Rows Per Page',
                      },
                    }}
                    title="Collections Report"
                    columns={[
                      {
                        title: 'Client',
                        field: 'client',
                        render: (data) => data.client,
                        sorting: false,
                      },
                      {
                        title: 'Current',
                        field: 'current',
                        render: (data) => data.current,
                        sorting: false,
                      },
                      {
                        title: 'Past Due 0-15 days',
                        field: 'zerotofifteendays',
                        render: (data) => data.zerotofifteendays,
                        sorting: false,
                      },
                      {
                        title: 'Past Due 16-30 days',
                        field: 'sixteentothirtydays',
                        render: (data) => data.sixteentothirtydays,
                        sorting: false,
                      },
                      {
                        title: 'Past Due 31-45 days',
                        field: 'thirtyonetofortyfivedays',
                        render: (data) => data.thirtyonetofortyfivedays,
                        sorting: false,
                      },
                      {
                        title: 'Past Due 46-60 days',
                        field: 'fortysixtosixtydays',
                        render: (data) => data.fortysixtosixtydays,
                        sorting: false,
                      },
                      {
                        title: 'Past Due 61-75 days',
                        field: 'sixtyonetoseventyfivedays',
                        render: (data) => data.sixtyonetoseventyfivedays,
                        sorting: false,
                      },
                      {
                        title: 'Past Due 76-90 days',
                        field: 'seventysixtonintydays',
                        render: (data) => data.seventysixtonintydays,
                        sorting: false,
                      },
                      {
                        title: 'Past Due <91',
                        field: 'morethannintyonedays',
                        render: (data) => data.morethannintyonedays,
                        sorting: false,
                      },
                      {
                        title: 'Past Due Balance',
                        field: 'pastduebalance',
                        render: (data) => data.pastduebalance,
                        sorting: false,
                      },
                      {
                        title: 'Overall Outstanding',
                        field: 'overalloutstanding',
                        render: (data) => data.overalloutstanding,
                        sorting: false,
                      },
                    ]}
                    data={
                      displayedTcData?.length
                        ? displayedTcData
                        : pastDueTableObject?.rows || [
                            {
                              client: 'Runflats México, S.A. de C.V.',
                              zerotofifteendays: '$2,437,830.74',
                              sixteentothirtydays: '$2,437,830.74',
                              thirtyonetofortyfivedays: '$2,437,830.74',
                              fortysixtosixtydays: '$2,437,830.74',
                              sixtyonetoseventyfivedays: '$2,437,830.74',
                              seventysixtonintydays: '$2,437,830.74',
                              morethannintyonedays: '$2,437,830.74',
                              pastduebalance: '$2,437,830.74',
                              overalloutstanding: '$2,437,830.74',
                            },
                            {
                              client: 'ALEXAR INTERNACIONAL S.A. DE C.V.',
                              zerotofifteendays: '$77,923.08',
                              sixteentothirtydays: '$77,923.08',
                              thirtyonetofortyfivedays: '$77,923.08',
                              fortysixtosixtydays: '$77,923.08',
                              sixtyonetoseventyfivedays: '$77,923.08',
                              seventysixtonintydays: '$0.00',
                              morethannintyonedays: '$77,923.08',
                              pastduebalance: '$77,923.08',
                              overalloutstanding: '$77,923.08',
                            },
                            {
                              client: 'NEMAK AUTOMOTIVE S.A. DE C.V.',
                              zerotofifteendays: '$0.00',
                              sixteentothirtydays: '$2,437,830.74',
                              thirtyonetofortyfivedays: '$0.00',
                              fortysixtosixtydays: '$0.00',
                              sixtyonetoseventyfivedays: '$0.00',
                              seventysixtonintydays: '$0.00',
                              morethannintyonedays: '$0.00',
                              pastduebalance: '$0.00',
                              overalloutstanding: '$0.00',
                            },
                            {
                              client: 'Fronius Mexico S.A de C.V.',
                              zerotofifteendays: '$84,680.33',
                              sixteentothirtydays: '$84,680.33',
                              thirtyonetofortyfivedays: '$84,680.33',
                              fortysixtosixtydays: '$84,680.33',
                              sixtyonetoseventyfivedays: '$84,680.33',
                              seventysixtonintydays: '$84,680.33',
                              morethannintyonedays: '$84,680.33',
                              pastduebalance: '$0.00',
                              overalloutstanding: '$84,680.33',
                            },
                            {
                              client: 'NEMAK MEXICO S.A. (MXN)',
                              zerotofifteendays: '$2,437,830.74',
                              sixteentothirtydays: '$0.00',
                              thirtyonetofortyfivedays: '$0.00',
                              fortysixtosixtydays: '$0.00',
                              sixtyonetoseventyfivedays: '$2,437,830.74',
                              seventysixtonintydays: '$0.00',
                              morethannintyonedays: '$0.00',
                              pastduebalance: '$0.00',
                              overalloutstanding: '$0.00',
                            },
                            {
                              client: 'ATPAK S.A. DE C.V. (USD)',
                              zerotofifteendays: '$2,437,830.74',
                              sixteentothirtydays: '$2,437,830.74',
                              thirtyonetofortyfivedays: '$2,437,830.74',
                              fortysixtosixtydays: '$2,437,830.74',
                              sixtyonetoseventyfivedays: '$2,437,830.74',
                              seventysixtonintydays: '$2,437,830.74',
                              morethannintyonedays: '$2,437,830.74',
                              pastduebalance: '$2,437,830.74',
                              overalloutstanding: '$2,437,830.74',
                            },
                            {
                              client: 'VECTOR GLOBAL LOGISTICS LLC (USD)',
                              zerotofifteendays: '$0.00',
                              sixteentothirtydays: '$0.00',
                              thirtyonetofortyfivedays: '$0.00',
                              fortysixtosixtydays: '$2,437,830.74',
                              sixtyonetoseventyfivedays: '$2,437,830.74',
                              seventysixtonintydays: '$0.00',
                              morethannintyonedays: '$0.00',
                              pastduebalance: '$0.00',
                              overalloutstanding: '$0.00',
                            },
                            {
                              client: 'NEMAK MEXICO S.A.',
                              zerotofifteendays: '$2,437,830.74',
                              sixteentothirtydays: '$77,923.08',
                              thirtyonetofortyfivedays: '$77,923.08',
                              fortysixtosixtydays: '$77,923.08',
                              sixtyonetoseventyfivedays: '$77,923.08',
                              seventysixtonintydays: '$77,923.08',
                              morethannintyonedays: '$77,923.08',
                              pastduebalance: '$77,923.08',
                              overalloutstanding: '$77,923.08',
                            },
                            {
                              client: 'Runflats México, S.A. de C.V.',
                              zerotofifteendays: '$0.00',
                              sixteentothirtydays: '$0.00',
                              thirtyonetofortyfivedays: '$0.00',
                              fortysixtosixtydays: '$0.00',
                              sixtyonetoseventyfivedays: '$0.00',
                              seventysixtonintydays: '$0.00',
                              morethannintyonedays: '$0.00',
                              pastduebalance: '$0.00',
                              overalloutstanding: '$0.00',
                            },
                            {
                              client: 'NEMAK AUTOMOTIVE S.A. DE C.V.',
                              zerotofifteendays: '$2,437,830.74',
                              sixteentothirtydays: '$2,437,830.74',
                              thirtyonetofortyfivedays: '$2,437,830.74',
                              fortysixtosixtydays: '$2,437,830.74',
                              sixtyonetoseventyfivedays: '$2,437,830.74',
                              seventysixtonintydays: '$2,437,830.74',
                              morethannintyonedays: '$2,437,830.74',
                              pastduebalance: '$2,437,830.74',
                              overalloutstanding: '$2,437,830.74',
                            },
                            {
                              client: 'ATPAK S.A. DE C.V. (USD)',
                              zerotofifteendays: '$0.00',
                              sixteentothirtydays: '$0.00',
                              thirtyonetofortyfivedays: '$2,437,830.74',
                              fortysixtosixtydays: '$0.00',
                              sixtyonetoseventyfivedays: '$0.00',
                              seventysixtonintydays: '$0.00',
                              morethannintyonedays: '$0.00',
                              pastduebalance: '$0.00',
                              overalloutstanding: '$0.00',
                            },
                            {
                              client: 'VECTOR GLOBAL LOGISTICS LLC (USD)',
                              zerotofifteendays: '$0.00',
                              sixteentothirtydays: '$2,437,830.74',
                              thirtyonetofortyfivedays: '$0.00',
                              fortysixtosixtydays: '$0.00',
                              sixtyonetoseventyfivedays: '$0.00',
                              seventysixtonintydays: '$0.00',
                              morethannintyonedays: '$0.00',
                              pastduebalance: '$0.00',
                              overalloutstanding: '$0.00',
                            },
                            {
                              client: 'ALEXAR INTERNACIONAL S.A. DE C.V.',
                              zerotofifteendays: '$77,923.08',
                              sixteentothirtydays: '$77,923.08',
                              thirtyonetofortyfivedays: '$77,923.08',
                              fortysixtosixtydays: '$77,923.08',
                              sixtyonetoseventyfivedays: '$77,923.08',
                              seventysixtonintydays: '$77,923.08',
                              morethannintyonedays: '$0.00',
                              pastduebalance: '$77,923.08',
                              overalloutstanding: '$1,637,115.06',
                            },
                            {
                              client: 'NEMAK MEXICO S.A.',
                              zerotofifteendays: '$84,680.33',
                              sixteentothirtydays: '$84,680.33',
                              thirtyonetofortyfivedays: '$84,680.33',
                              fortysixtosixtydays: '$0.00',
                              sixtyonetoseventyfivedays: '$84,680.33',
                              seventysixtonintydays: '$84,680.33',
                              morethannintyonedays: '$84,680.33',
                              pastduebalance: '$84,680.33',
                              overalloutstanding: '$2,437,830.74',
                            },
                            {
                              client: 'TOTAL',
                              zerotofifteendays: '$184,643.41',
                              sixteentothirtydays: '$184,643.41',
                              thirtyonetofortyfivedays: '$184,643.41',
                              fortysixtosixtydays: '$184,643.41',
                              sixtyonetoseventyfivedays: '$184,643.41',
                              seventysixtonintydays: '$184,643.41',
                              morethannintyonedays: '$184,643.41',
                              pastduebalance: '$184,643.41',
                              overalloutstanding: '$184,643.41',
                            },
                          ]
                    }
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end" alignItems="flex-end" height={1} mt={0.5}>
              <Box display="flex" justifyContent="flex-end" alignItems="center">
                <Box>
                  <Link color="textPrimary" value={subTabValue} index={1}>
                    <Typography variant="body2">View all</Typography>
                  </Link>
                </Box>
                <Box className={classes.ViewAll}>
                  <ArrowForwardIcon />
                </Box>
              </Box>
            </Box>
          </Grid> */}
        </If>
        <If condition={!cellDetails?.qbId}>
          Please add your cell&rsquo;s Quickbooks Id in the system to see collection section
        </If>
      </If>
    </>
  );
};
CollectionReport.propTypes = {
  collectionDataFromImportProp: PropTypes.arrayOf(PropTypes.object).isRequired, // Adjust the type as needed
  pastDueInvoicesArr: PropTypes.arrayOf(PropTypes.object).isRequired, // Adjust the type as needed
  pastDueTableArr: PropTypes.arrayOf(PropTypes.object).isRequired, // Adjust the type as needed
};
export default CollectionReport;
